import React, { useCallback } from 'react';

import { getSeverity } from 'pages/item/v2/components/ProtectedData';
import { HistoryOfChangesItem } from 'pages/item/v2/types/history-of-changes';
import get from 'utils/get';
import isEmpty from 'utils/is-empty';
import isNil from 'utils/is-nil';

import ScorePane from '../ScorePane';
import TrendTooltip from '../TrendTooltip';

interface Props {
    version: 2 | 3 | 4;
    data: {
        score: number;
        vector: string;
    };
}

const CnaCvss: React.FC<Props> = ({ data, version }) => {
    const label = `cvss${version}`.toUpperCase();

    const getChart = useCallback(
        (historyData: HistoryOfChangesItem[]) => {
            if (historyData.every(({ changes }) => isNil(get(changes, ['cna_cvss', 'cvss', version])))) return null;

            return historyData.reduce((output, { version, published, changes }) => {
                const score = get<number>(changes, ['cna_cvss', 'cvss', version, 'score']) ?? output.at(-1)?.score ?? 0;
                output.push({ version, score, published });
                return output;
            }, [] as { score: number; version: number; published: Date }[]);
        },
        [version]
    );

    if (isEmpty(data, { recursive: true })) {
        return null;
    }

    const { score, vector } = data;

    return (
        <TrendTooltip getChart={getChart} title={`{label} score statistics`}>
            <ScorePane score={score} severity={getSeverity(score)} name={label} vector={vector} />
        </TrendTooltip>
    );
};

export default CnaCvss;
